import {User} from './shiftHandover.types'

export enum KpiCalculationError {
  NoKpiValue = 'noKpiValue',
  AmbiguousKpiValues = 'ambiguousKpiValues',
  EmptyKpiValue = 'emptyKpiValue',
  EquipmentNotRunning = 'equipmentNotRunning',
  UnrecognizedControlString = 'unrecognizedControlString',
  InvalidNumericValue = 'invalidNumericValue'
}

export enum ExpertSystemHierarchyNodeType {
  Global = 'global',
  Area = 'area',
  Region = 'region',
  Country = 'country',
  Plant = 'plant',
  KilnKpi = 'kilnKpi',
  MillKpi = 'millKpi'
}

export enum MillType {
  VerticalMill = 'verticalMill',
  RollerPress = 'rollerPress',
  BallMill = 'ballMill'
}

type HierarchyAccess = {
  canReadNode: boolean
  canWriteNode: boolean
}

export enum InstallationStatus {
  Completed = 'completed',
  InProgress = 'inProgress',
  Pending = 'pending',
  FreeText = 'freeText'
}

export type ExpertSystemHierarchyNode = {
  id: string
  name: string
  type: ExpertSystemHierarchyNodeType
  countryCode?: string
  materializedPath: string
  kpiAssignmentId?: number
  expertSystemName?: string
  millType?: MillType
  children: ExpertSystemHierarchyNode[]
  responsibles: User[]
  access: HierarchyAccess
  provider?: string
  upmDepartmentId?: string
  installationStatus?: InstallationStatus
  installationStatusText?: string
  installationYear?: number
}
